module.exports = __webpack_public_path__ + "static/media/expand.7b5938fc.svg";